import { ResponseStatus } from '@revenuemarket/http';
import { BasicPartnerListResponse } from '@revenuemarket/utils/partners/usePartners';
import { useQuery } from '@tanstack/react-query';

import { getPartners } from '~apis/partners';

export const usePartners = (code?: string) => {
  return useQuery({
    queryKey: ['partners', 'basic', code],
    queryFn: async (): Promise<BasicPartnerListResponse | null> => {
      try {
        const response = await getPartners(code);

        if (response.Status === ResponseStatus.SUCCESS && response.Data) {
          return response.Data.data;
        }

        // API 응답이 실패한 경우 null 반환 (fallback 사용을 위해)
        console.warn('Partners API returned unsuccessful response:', response);
        return null;
      } catch (error) {
        // 네트워크 에러나 기타 예외 발생 시 null 반환 (fallback 사용을 위해)
        console.error('Failed to fetch partners:', error);
        return null;
      }
    },
    enabled: typeof window !== 'undefined', // 클라이언트 사이드에서만 활성화
    retry: 1, // 재시도 횟수 제한
    retryDelay: 1000, // 재시도 간격
    staleTime: 5 * 60 * 1000, // 5분간 캐시 유지
    cacheTime: 10 * 60 * 1000, // 10분간 메모리에 보관
    refetchOnWindowFocus: false, // 윈도우 포커스 시 재요청 비활성화
    refetchOnReconnect: true, // 네트워크 재연결 시 재요청
    useErrorBoundary: false, // 에러를 Error Boundary로 전파하지 않음
  });
};
